import { Dispatch } from 'redux';

import { fetcher } from '../../lib/request';

import { SearchHotel } from '../../models/Hotels/SearchHotel';
import { SearchRegion } from '../../models/Hotels/SearchRegion';
import { Residency } from '../../models/Hotels/Residency';

const HOTELS_HOST = process.env.REACT_APP_HOTELS_HOST;
const HOTELS_KEY = process.env.REACT_APP_HOTELS_KEY;

export const SEARCH_REQUEST = 'HOTELS_SEARCH_REQUEST';
export const SEARCH_RESPONSE = 'HOTELS_SEARCH_RESPONSE';
export const SEARCH_ERROR = 'HOTELS_SEARCH_ERROR';

export const RESET_SEARCH = 'HOTELS_RESET_SEARCH';

export const SET_HOTEL = 'HOTELS_SET_HOTEL';
export const SET_REGION = 'HOTELS_SET_REGION';

export const SEARCH_QUERY = 'SEARCH_QUERY';

export const SEARCH_RESIDENCIES_REQUEST = 'HOTELS_SEARCH_RESIDENCIES_REQUEST';
export const SEARCH_RESIDENCIES_RESPONSE = 'HOTELS_SEARCH_RESIDENCIES_RESPONSE';
export const SEARCH_RESIDENCIES_ERROR = 'HOTELS_SEARCH_RESIDENCIES_ERROR';

export const SEARCH_RESIDENCY_QUERY = 'HOTELS_SEARCH_RESIDENCY_QUERY';
export const RESET_RESIDENCY_SEARCH = 'HOTELS_RESET_RESIDENCY_SEARCH';
export const SET_RESIDENCY = 'HOTELS_SET_RESIDENCY';

export const setHotelAction = (hotel: SearchHotel) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_HOTEL,
    hotel
});

export const setRegionAction = (region: SearchRegion) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_REGION,
    region
});

export const resetSearchAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_SEARCH
});

export const searchResultsAction = (query: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SEARCH_REQUEST
    });

    try {
        const response = await fetcher(`${HOTELS_HOST}/v3/autocomplete?query=${query}&lang=ru`)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: SEARCH_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: SEARCH_ERROR,
            error
        });
    }
};

export const searchResidenciesAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SEARCH_RESIDENCIES_REQUEST
    });

    try {
        const response = await fetcher(`${HOTELS_HOST}/v3/residencies`)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: SEARCH_RESIDENCIES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: SEARCH_RESIDENCIES_ERROR,
            error
        });
    }
};

export const setSearchQueryAction = (query: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SEARCH_QUERY,
    query
});

export const setResidencyQueryAction = (query: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SEARCH_RESIDENCY_QUERY,
    query
});

export const resetResidencySearchAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_RESIDENCY_SEARCH
});

export const setResidencyAction = (residency: Residency) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_RESIDENCY,
    residency
});



// WEBPACK FOOTER //
// ./src/actions/Hotels/search.ts